module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo16.7d094744.jpg";